import { render, staticRenderFns } from "./accountantSummaryDistribution.vue?vue&type=template&id=97d4d1ec"
import script from "./accountantSummaryDistribution.vue?vue&type=script&lang=js"
export * from "./accountantSummaryDistribution.vue?vue&type=script&lang=js"
import style0 from "./accountantSummaryDistribution.vue?vue&type=style&index=0&id=97d4d1ec&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports